import { http, HttpResponse, HttpResponseResolver, delay } from "msw";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import { ApiCatalog } from "@/api";
import { v3SchoolThroughTeacherMock } from "./queries.test.mock";
import type { V3SchoolThroughTeacherResponse } from "./queries.type";

export const createV3SchoolThroughTeacherQueryHandler = (
  {
    defaultData,
    status,
  }: {
    defaultData?: Partial<V3SchoolThroughTeacherResponse> | undefined;
    status?: number;
  } = {
    defaultData: v3SchoolThroughTeacherMock,
    status: 200,
  },
) => {
  const mockedResolver = jest.fn(async () => {
    await delay(100);
    return HttpResponse.json(defaultData || v3SchoolThroughTeacherMock, {
      status: status || 200,
    });
  }) as unknown as jest.MockedFunction<HttpResponseResolver>;
  const get = http.get(
    `${MONOLITH_ORIGIN}${ApiCatalog.schoolThroughTeacher.endpoint.replace(
      "[id]",
      "me",
    )}`,
    mockedResolver,
  );
  return {
    get,
    mockedResolver,
  };
};
